<div class="merge-patient-modal" [ngStyle]="{ 'display': hideMainModel? 'none':'block'}">
  <div class="modal__content u-mt">
    <div class="box-content">
      <div class="u--1/2 flex-gap" [class.u-mr++]="!showSwapIcon">
        <div class="u-pb0">
          <span class="text-18 u-small-mb">{{ 'mergePatient.selectedPatient' | translate}}</span>
        </div>
        <div class="selected-patient-box">
          <app-patient-view
            [item]="sourcePatient"
            [showHeader]="showSwapIcon"
            [headerTitle]="'mergePatient.source' | translate"
          ></app-patient-view>
        </div>
      </div>
      <div *ngIf="showSwapIcon" class="swapIcon" >
      <button [disabled]="!allowSwap" (click)="swapPatient()" class="button button--secondary swap-button">
        <svg-icon
          name="ico-exchange-16"
          [svgStyle]="{ 'width.px': 20, 'height.px': 20, fill: 'currentColor' }"
        >
        </svg-icon>
      </button>
    </div>
      <div class="u--1/2 right-box flex-gap">
        <div class="u-pb0 u-ml-- right-box-head">
          <span class="text-18" tooltip="{{ rightBoxTitle | translate}}">{{ rightBoxTitle | translate}}</span>
          <button
            *ngIf="!showSearchForm"
            id="back-icon"
            aria-label="Clear"
            class="button button--tertiary button--no-border back-button u-pb0 u-pr0"
            (click)="goBack()"
            [disabled]="patientSwapped"
            tooltip="{{ backButtonLabel | translate}}"
          >
            <svg-icon
              name="ico-arrow-left-16"
              [svgStyle]="{ 'width.px': 16, 'height.px': 13, fill: 'currentColor' }"
              class="u-mr---"
            ></svg-icon>
            {{ backButtonLabel | translate}}
          </button>
        </div>
        <div *ngIf="showSearchForm; else searchResult" class="search-patient-box">
          <app-search-patient
            [searchFormValue]="searchFormValue"
            (searchPatient)="searchPatientList($event)"
          ></app-search-patient>
        </div>
        <ng-template #searchResult>
          <div class="flex search-result-box" *ngIf="(destinationPatient | json) === '{}'; else selectedPatient">
            <app-search-result
              [searchFormValue]="searchFormValue"
              [patientList]="patientList"
              [sourcePatientId]="sourcePatient.patientCkey"
              (selectPatient)="selectDestinationPatient($event)"
            ></app-search-result>
          </div>
        </ng-template>
        <ng-template #selectedPatient>
          <div class="destination-patient-box">
          <app-patient-view
            [item]="destinationPatient"
            [showHeader]="showSwapIcon"
            [headerTitle]="'mergePatient.destination' | translate"
            (manageSwapVisibility)="manageSwapVisibility($event)"
          ></app-patient-view>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="modal__footer u-pt--">
    <button
      type="button"
      class="button button--primary button--accept"
      [disabled]="(destinationPatient | json) === '{}' "
      (click)="openMergePatientConfirmation($event)"
    >
      {{"mergePatient.label" | translate }}
    </button>
    <button type="button" class="button button--reject button--tertiary" (click)="closeModal($event)">{{"label.cancel" | translate }}</button>
  </div>
</div>
